import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import PanelSelectedChargesDisplay from './PanelSelectedChargesDisplay'
import TriangleAlert from '../sharedPanelComponents/TriangleAlert'
import { getCptEncTypeMismatch } from '../PanelSummaryComponents/panelSummaryHelpers'

export default function PanelChargeEmDisplay({ emCode, setSelectedCPT, disabled }) {
  const [errorMsg, setErrorMsg] = useState('')

  const encounterType = useSelector((state) => state.sidePanel.panelEncounter?.encounterType)

  useEffect(() => {
    setErrorMsg(
      getCptEncTypeMismatch({
        encounterType,
        emCode,
      }),
    )
  }, [encounterType, emCode])

  return (
    <div id={'PanelChargeEmDisplay'}>
      <div className={'d-flex flex-column display-box emInfo'}>
        <div className={'boxTitle'} style={{ pointerEvents: disabled ? 'none' : 'auto' }}>
          E&M
        </div>
        {errorMsg && (
          <div className={'cptEncTypeMismatch'}>
            <TriangleAlert />
            {errorMsg}
          </div>
        )}

        <PanelSelectedChargesDisplay
          selectedCPT={emCode ? [emCode] : []}
          setSelectedCPT={setSelectedCPT}
        />
      </div>
    </div>
  )
}
